<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-bath"></i> Banho
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Clinica</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.clinica"
                                    />
                                </div>
                                <div :class="{ 'has-danger': $v.model.data.$error }">
                                    <label>Data*</label>
                                    <flat-pickr
                                        v-model="model.data"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>
                                <div class="col-md-2">
                                    <label>Preço</label>
                                    <money v-model="model.preco" class="form-control"></money>
                                </div>
                                <div class="col-md-3 align-self-center">
                                    <label>Realizado?</label>
                                    <br />
                                    <input-toggle
                                        v-model="model.realizado"
                                        :value="model.realizado"
                                    ></input-toggle>
                                </div>
                            </div>
                            <div class="form-group row"></div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Observações</label>
                                    <textarea
                                        rows="6"
                                        cols="60"
                                        type="text"
                                        maxlength="1000"
                                        class="form-control"
                                        v-model="model.observacao"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{name: 'list-bath-pet', params: { id: this.$route.params.id}}"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Collections from "@/helpers/collections";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

export default {
    components: { Select2, FileImage, SelectApi, flatPickr },
    data() {
        return {
            model: {
                id: null,
                clinica: "",
                data: "",
                veterinario: "",
                numeroInscricao: "",
                observacao: "",
                idPet: "",
                realizado: 0,
                preco: ""
            },
            file: null,
            config: {
                wrap: true,
                enableTime: true,
                time_24hr: true,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y H:i",
                allowInput: true
            }
        };
    },
    validations() {
        return {
            model: {
                data: {
                    required
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            vm.model.idPet = this.$route.params.id;

            if (vm.model.id) {
                let ret = facade.updateBath(vm.model, vm.model.id);
                ret.then(bath => {
                    this.$router.push({
                        name: "list-bath-pet",
                        params: {
                            id: this.$route.params.id,
                            idBath: this.$route.params.idBath
                        }
                    });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                try {
                    let ret = facade.createBath(vm.model);
                    ret.then(bath => {
                        this.$router.push({
                            name: "list-bath-pet",
                            params: {
                                id: this.$route.params.id,
                                idBath: this.$route.params.id
                            }
                        });
                        this.$loading.show(false);
                    }).catch(e => {
                        e.forEach(item => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    });
                } catch (e) {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                }
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(bath) {
            let vm = this;
            if (bath !== undefined && bath !== null) {
                this.model = bath;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([
            to.params.idBath ? facade.getBath(to.params.idBath) : null
        ])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?e097e2cc